import { c as _c } from "react/compiler-runtime";
import React from "react";
import { ApiDrop } from "@/generated/models/ObjectSerializer";
import Link from "next/link";
import UserCICAndLevel, { UserCICAndLevelSize } from "@/components/user/utils/UserCICAndLevel";
import { cicToType } from "@/helpers/Helpers";
import UserProfileTooltipWrapper from "@/components/utils/tooltip/UserProfileTooltipWrapper";
interface SingleWaveDropAuthorProps {
  readonly drop: ApiDrop;
}
export const SingleWaveDropAuthor: React.FC<SingleWaveDropAuthorProps> = t0 => {
  const $ = _c(17);
  const {
    drop
  } = t0;
  const t1 = `/${drop.author.handle}`;
  let t2;
  if ($[0] !== drop.author.pfp) {
    t2 = drop.author.pfp ? <img className="tw-size-10 tw-rounded-md tw-ring-1 tw-ring-inset tw-ring-white/10 tw-object-contain tw-bg-iron-900" src={drop.author.pfp} alt="User avatar" /> : <div className="tw-size-10 tw-rounded-md tw-ring-1 tw-ring-inset tw-ring-white/10 tw-bg-iron-800" />;
    $[0] = drop.author.pfp;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = drop.author.level;
  let t4;
  if ($[2] !== drop.author.cic) {
    t4 = cicToType(drop.author.cic);
    $[2] = drop.author.cic;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== drop.author.level || $[5] !== t4) {
    t5 = <UserCICAndLevel level={t3} cicType={t4} size={UserCICAndLevelSize.SMALL} />;
    $[4] = drop.author.level;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const t6 = drop.author.handle ?? drop.author.id;
  let t7;
  if ($[7] !== drop.author.handle) {
    t7 = <span className="tw-text-md tw-font-medium tw-text-iron-200 desktop-hover:hover:tw-text-opacity-80">{drop.author.handle}</span>;
    $[7] = drop.author.handle;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t6 || $[10] !== t7) {
    t8 = <UserProfileTooltipWrapper user={t6}>{t7}</UserProfileTooltipWrapper>;
    $[9] = t6;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t1 || $[13] !== t2 || $[14] !== t5 || $[15] !== t8) {
    t9 = <Link href={t1} className="tw-flex tw-items-center tw-gap-x-3 tw-no-underline desktop-hover:hover:tw-underline">{t2}{t5}{t8}</Link>;
    $[12] = t1;
    $[13] = t2;
    $[14] = t5;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  return t9;
};